import * as React from "react";
import { Theme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import { Alert } from '@mui/material';
import { AlertColor } from '@mui/material/Alert';
import { useState } from "react";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

interface IAlertBlockProps {
  type: AlertColor;
  onClose?: () => any;
  hideCloseButton?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  alert: {
    width: "100%",
    margin: theme.spacing(0, 0, 1)
  }
}));

const AlertBlock: React.FC<IAlertBlockProps> = (props): JSX.Element => {
  const classes = useStyles({});
  const [open, setOpen] = useState(!!props.children);

  return (
    <Collapse in={open} className={classes.alert}>
      <Alert
        style={{ wordBreak: "break-word" }}
        action={
          props.hideCloseButton ? null : (
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
                if (typeof props.onClose !== "undefined") {
                  props.onClose();
                }
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          )
        }
        severity={props.type}
      >
        {props.children}
      </Alert>
    </Collapse>
  );
};

export default AlertBlock;
